const CalendarConfig = {
  shortMonthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  daysNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  shortDaysNames: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
}

export const shortMonthNames = CalendarConfig.shortMonthNames
export const monthNames = CalendarConfig.monthNames
export const daysNames = CalendarConfig.daysNames
export const shortDaysNames = CalendarConfig.shortDaysNames

export default CalendarConfig
